/* tslint:disable */
/* eslint-disable */
/**
 * Retool API
 * The Retool API is in beta. Go to Settings > API to get started. Once you generate an API token, use bearer token authentication to make requests.
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Custom Component Library Revision
 * @export
 * @interface CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner
 */
export interface CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner {
    /**
     * 
     * @type {string}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner
     */
    customComponentLibraryId: string;
    /**
     * 
     * @type {Date}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner interface.
 */
export function instanceOfCustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "version" in value;
    isInstance = isInstance && "customComponentLibraryId" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInnerFromJSON(json: any): CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner {
    return CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInnerFromJSONTyped(json, false);
}

export function CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'version': json['version'],
        'customComponentLibraryId': json['custom_component_library_id'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInnerToJSON(value?: CustomComponentLibrariesLibraryIdRevisionsGet200ResponseDataInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'version': value.version,
        'custom_component_library_id': value.customComponentLibraryId,
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
    };
}

